'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dSites$002dPage$0024 from "./presto.-List-Sites-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002487 from "./presto.-Presto-Router$$anon$87.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$86() {
  this.boC = null;
  this.bou = null;
  this.bov = false;
  this.boD = null;
  this.boE = false;
  this.boH = null;
  this.boA = null;
  this.boB = false;
  this.bow = null;
  this.box = false;
  this.boy = null;
  this.boz = false;
  this.boF = false;
  this.boG = false;
  this.boC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.boH = "ListSitesPage";
}
export { $c_Lpresto_PrestoRouter$$anon$86 as $c_Lpresto_PrestoRouter$$anon$86 };
$p = $c_Lpresto_PrestoRouter$$anon$86.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$86;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$86() {
}
export { $h_Lpresto_PrestoRouter$$anon$86 as $h_Lpresto_PrestoRouter$$anon$86 };
$h_Lpresto_PrestoRouter$$anon$86.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.boC;
});
$p.L = (function() {
  if ((!this.bov)) {
    this.bou = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bov = true;
  }
  return this.bou;
});
$p.O = (function() {
  if ((!this.boE)) {
    this.boD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.boE = true;
  }
  return this.boD;
});
$p.E = (function() {
  return this.boH;
});
$p.t = (function() {
  if ((!this.boB)) {
    this.boA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.boB = true;
  }
  return this.boA;
});
$p.M = (function() {
  if ((!this.box)) {
    this.bow = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.box = true;
  }
  return this.bow;
});
$p.Q = (function() {
  if ((!this.boz)) {
    this.boy = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002487.$c_Lpresto_PrestoRouter$$anon$87();
    this.boz = true;
  }
  return this.boy;
});
$p.w = (function() {
  if ((!this.boG)) {
    this.boF = false;
    this.boG = true;
  }
  return this.boF;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee556) => ((p) => \u03b4scrutinee556))($j_presto$002e$002dList$002dSites$002dPage$0024.$m_Lpresto_ListSitesPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$86 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$86, "presto.PrestoRouter$$anon$86", ({
  OV: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$86 as $d_Lpresto_PrestoRouter$$anon$86 };
//# sourceMappingURL=presto.-Presto-Router$$anon$86.js.map
